// gdpr function for get cookies
import { getCookie } from '../service/cookieService';

const CONSENT_COOKIE = 'GDPR_C';
const IS_GDPR_REGION_COOKIE = 'isGdprRegion';
const CONSENT_VALUE = {
  NON_ESSENTIAL: '12',
  INITIAL_STATE: 'IS',
  ESSENTIAL: '11',
};

export const isEnableNonEssentialDataPush = () => {
  const isGdprRegion = +getCookie(IS_GDPR_REGION_COOKIE);
  const gdprConsentClient = getCookie(CONSENT_COOKIE);
  if (!isGdprRegion) {
    return true;
  }
  if (gdprConsentClient === CONSENT_VALUE.NON_ESSENTIAL && isGdprRegion) {
    return true;
  }
  return false;
};

export const isGdprRegion = () => +getCookie(IS_GDPR_REGION_COOKIE);
